<template>
  <div>
    <table-component
      ref="queryTable"
      :data="fetchData"
      sort-by="order"
      sort-order="asc"
      :show-caption="false"
      class="datatable"
      filter-placeholder=""
      filterNoResults="">
      <table-column
        show="order"
        :filterable="false"
        :hidden="true">
      </table-column>
      <table-column
        show="star"
        :label="$t('query.star')"
        :sortable="true"
        :filterable="false"
        header-class="table-component__minimum__width__column"
        cell-class="text-center">
        <template slot-scope="row">
          <font-awesome-icon
            @click="onClickStar(row)"
            :icon="row.star ? icon.starIcon : icon.starIconEmpty"
            :class="starClass(row)"/>
        </template>
      </table-column>
      <table-column
        show="name"
        :label="$t('query.name')"
        header-class="text-left"
        cell-class="table-component__text-left">
        <template slot-scope="row">
          <span
            @click="onStoredQuery(row.relativePath)"
            class="query-data-table-clickable">
              {{ row.name }}
          </span>
        </template>
      </table-column>
      <table-column
        show="owner"
        header-class="text-left"
        cell-class="table-component__text-left"
        :label="$t('query.owner')">
      </table-column>
      <table-column
        :label="$t('variables.tags')"
        :filterable="false"
        :sortable="false">
        <template
          slot-scope="row">
          <tags
            :value="row.tags" />
        </template>
      </table-column>
      <table-column
        label=""
        :sortable="false"
        :filterable="false"
        header-class="table-component__minimum__width__column"
        cell-class="text-center">
        <template slot-scope="row">
          <font-awesome-icon
            v-if="row.canShare"
            :id="row"
            v-on:click="onShare(row)"
            :icon="icon.shareIcon"
            class="table-iconset-icon"/>
          <font-awesome-icon
            v-else
            :icon="icon.shareIcon"
            class="table-icon-disabled"/>
        </template>
      </table-column>
      <table-column
        label=""
        :sortable="false"
        :filterable="false"
        header-class="table-component__minimum__width__column"
        cell-class="text-center">
        <template slot-scope="row">
          <font-awesome-icon
            v-if="row.canEdit"
            :id="row"
            v-on:click="onUpdate(row)"
            :icon="icon.pencilIcon"
            class="table-iconset-icon"/>
          <font-awesome-icon
            v-else
            :icon="icon.pencilIcon"
            class="table-icon-disabled"/>
        </template>
      </table-column>
      <table-column
        label=""
        :sortable="false"
        :filterable="false"
        header-class="table-component__minimum__width__column"
        cell-class="text-center">
        <template slot-scope="row">
          <font-awesome-icon
            v-if="row.canDelete"
            :id="row"
            v-on:click="onDelete(row)"
            :icon="icon.trashIcon"
            class="table-iconset-icon"/>
          <font-awesome-icon
            v-else
            :icon="icon.trashIcon"
            class="table-icon-disabled"/>
        </template>
      </table-column>
    </table-component>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {
  faPencilAlt,
  faStar as faStarEmpty,
  faTrashAlt,
  faKey
} from '@fortawesome/pro-regular-svg-icons';
import {faStar} from '@fortawesome/pro-solid-svg-icons';
import TableComponent from '@/components/shared/table/components/TableComponent';
import TableColumn from '@/components/shared/table/components/TableColumn';
import Tags from '@/components/variable/Tags';

export default {
  components: {
    Tags,
    TableComponent,
    TableColumn,
    FontAwesomeIcon
  },
  props: {
    fetchData: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      icon: {
        starIcon: faStar,
        starIconEmpty: faStarEmpty,
        pencilIcon: faPencilAlt,
        trashIcon: faTrashAlt,
        shareIcon: faKey
      }
    };
  },
  methods: {
    refresh () {
      this.$refs.queryTable.refresh();
    },
    onStoredQuery (path) {
      this.$emit('onStoredQuery', path);
    },
    onUpdate (query) {
      this.$emit('onUpdate', query);
    },
    onDelete (query) {
      this.$emit('onDelete', query);
    },
    onShare (query) {
      this.$emit('onShare', query);
    },
    onClickStar (query) {
      this.$emit('onClickStar', query);
    },
    starClass (query) {
      return query.mine ? 'table-iconset-icon' : 'table-icon-disabled';
    }
  }
};

</script>

<style lang="scss">
  @import "../../stylesheets/variables.scss";

  .query-data-table-clickable {
    cursor: pointer;
    color: $link;
  }
</style>



// WEBPACK FOOTER //
// src/components/query/QueryDataTable.vue